/**
 * 站点名
 * @const
 */
export const SiteName = "Paddy的签名档"

/**
 * 站点描述
 */
export const Describe = "欢迎访问屑Paddy的签名档"

/**
 * 站点作者
 */
export const Author = {
	name: "Paddy",
	site: "mailto:paddy7594@gmail.com", //也可使用mailto
	homepage: "https://hello.paddy233-blog.ml",
	github: "Paddy2333"
}